import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthRoute } from './auth/AuthRoute';
import { AppShell } from '@components/AppShell';
import { AuthErrorBanner } from '@components/AuthErrorBanner';
import { Login } from '@pages/Login';
import { InboundQueue } from '@pages/InboundQueue';
import { OptInRoute } from '@pages/OptInQueue';
import { CallingQueue } from '@pages/CallingQueue';
import { LiveCall } from '@pages/LiveCall';
import { ConsentChase } from '@pages/ConsentChase';
import { FinalReview } from '@pages/FinalReview';
import { Archive } from '@pages/Archive';
import { ArchiveEntries } from '@pages/ArchiveEntries';
import { Lookup } from '@pages/Lookup';
import { Reports } from '@pages/Reports';
import { DncMaster, OptOutsTab, TechnicalExceptions, UspsTab } from '@pages/DncMaster';
import { EventPopout } from '@pages/EventPopout';
import { VideoTest } from '@pages/VideoTest';
import { useIdleLogoff } from '@lib/idle-logoff';

export function App() {
  useIdleLogoff();
  return (
    <>
      <AuthErrorBanner />
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* MSAL processes the redirect response in main.tsx before render; bounce to home. */}
        <Route path="/login/callback" element={<Navigate to="/" replace />} />
        {/* Pop-out single-event window (William 2026-07-14): auth-gated but OUTSIDE AppShell -
            one person, full window, no queue chrome. Opened by the drawer's "Pop out" button. */}
        <Route
          path="/event/:eventId"
          element={
            <AuthRoute>
              <EventPopout />
            </AuthRoute>
          }
        />
        <Route
          path="/"
          element={
            <AuthRoute>
              <AppShell />
            </AuthRoute>
          }
        >
          <Route index element={<InboundQueue />} />
          {/* Row 400: the Opt In lane under the Inbound queue; dark unless features.replyButtons (the page says so).
              Row 485: one route for the three menu lines 01A / 01B / 01C; the query names the lane. */}
          <Route path="inbound/opt-in" element={<OptInRoute />} />
          <Route path="calling" element={<CallingQueue />} />
          <Route path="live-call" element={<LiveCall />} />
          {/* De-navved by William 2026-07-06 (proactive lane parked); page stays reachable by URL. */}
          <Route path="consent-chase" element={<ConsentChase />} />
          <Route path="final-review" element={<FinalReview />} />
          <Route path="archive" element={<Archive />} />
          {/* R. 82 / row 401: nav 08's second view, the closed entries from member_care.db. */}
          <Route path="archive/entries" element={<ArchiveEntries />} />
          <Route path="lookup" element={<Lookup />} />
          <Route path="reports" element={<Reports />} />
          <Route path="optouts" element={<OptOutsTab />} />
          <Route path="usps-rejections" element={<UspsTab />} />
          <Route path="dnc" element={<DncMaster />} />
          <Route path="technical" element={<TechnicalExceptions />} />
          {/* Row 410: the Video (test) tab; dark unless features.videoLinks and the operator is on the test list (the page says so). */}
          <Route path="video-test" element={<VideoTest />} />
          {/* rev6: PCP lookup folded into Lookup as a tab; the old URL lands on that tab. */}
          <Route path="pcp-lookup" element={<Navigate to="/lookup?tab=pcp" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
